<template>
    <div class="bg-info">
        <q-scroll-area
            ref="scroll"
            style="height: 40px"
            horizontal
            :thumb-style="thumbStyle"
            :bar-style="barStyle"
        >
            <q-tabs
                v-model="tab"
                active-color="primary-2"
                active-bg-color="primary-2"
                inline-label
                class="text-black"
            >
                <q-tab
                    v-for="(item, index) in list"
                    :key="index"
                    :name="item.name"
                    no-caps
                >
                    {{ item.name }}
                </q-tab>
            </q-tabs>
        </q-scroll-area>
    </div>
</template>

<script>
export default {
    name: "CategoryLevel2Bar",
    // props: {
    //     L1: String,
    //     current: String,
    // },
    data() {
        return {
            tab: "",
            thumbStyle: {
                borderRadius: "1.5px",
                backgroundColor: "#282669",
                height: "0px",
                opacity: 1,
            },
            barStyle: {
                right: "2px",
                borderRadius: "9px",
                backgroundColor: "#027be3",
                width: "9px",
                opacity: 0,
            },
            itemCount: 0,
            list: [],
        };
    },
    computed: {
        L1() {
            return this.$store.state["allProduct"]["L1"];
        },
    },
    watch: {
        L1: {
            immediate: true,
            handler: function (value) {
                this.loadCatalogList(value);

                if (this.$refs.scroll) {
                    this.$refs.scroll.setScrollPosition(0);
                }

                if (this.list.length > 0) {
                    this.tab = this.list[0].name;
                    this.$store.commit("allProduct/setL2", this.tab);
                }
            },
        },
        tab: {
            handler: function (value) {
                // this.$emit("update-category", value);
                this.$store.commit("allProduct/setL2", value);
            },
        },
    },
    methods: {
        loadCatalogList(name) {
            if (this.$services.catalog.rootCategory.subCategory.get(name)) {
                const l = Array.from(
                    this.$services.catalog.rootCategory.subCategory
                        .get(name)
                        .subCategory.keys()
                ).map((item) => {
                    return {
                        name: item,
                    };
                });
                this.list = l;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.q-tab {
    padding: 0px 5px;
    margin: 7px 7px;
    height: 26px;
    min-height: unset;
    background-color: #f2f3f4;
    border-radius: 5px;
}
.q-tab__content {
    padding: 0px;
}
.q-tab__indicator {
    height: 0px !important;
}
.btn-category {
    cursor: pointer;
    padding: 0 10px;
    margin: 0 5px;
    /* background-color: #eaeaf1; */
    background-color: rgb(242, 243, 244);
}
.scroll {
    overflow-y: hidden;
}
.bg-primary-2 {
    background-color: #c0bfd5;
}
.text-primary-2 {
    color: #565590;
}
</style>

<style scoped>
>>> .q-tab--active .q-tab__indicator {
    height: 0px !important;
    opacity: 0 !important;
}
</style>
